import styled from 'styled-components';
import { HeImgix } from '../../../../../images/HeImgix';

export const CircleImage = styled(HeImgix)`
  border-radius: 16px;
  height: 32px;
  width: 32px;
`;
